<script setup lang="ts">
import { useSidebarStore } from '@/stores/sidebar'
import { HamburgerMenuIcon } from '@radix-icons/vue'
import CreateNewNav from './CreateNewNav.vue'
import MyTicketsNav from './MyTicketsNav.vue'
import SiteSearch from './SiteSearch.vue'
import UserFeedback from './UserFeedback.vue'
import UserNav from './UserNav.vue'
import { Avatar, AvatarImage } from './ui/avatar'
import Button from './ui/button/Button.vue'
import { defineAsyncComponent } from 'vue'

const UserNotifications = defineAsyncComponent(
    () => import('@/components/ui/button/UserNotifications.vue')
)

const NewTickets = defineAsyncComponent(() => import('@/components/NewTicketsNav.vue'))

const sidebarStore = useSidebarStore()
</script>

<template>
    <div class="grid grid-cols-3 items-center px-4 py-3 border-b sticky top-0 bg-white z-10">
        <div class="flex items-center">
            <Button variant="icon" size="icon" class="shrink-0" @click="sidebarStore.toggle()">
                <HamburgerMenuIcon />
            </Button>
            <div>
                <RouterLink to="/" class="flex-1 flex items-center">
                    <Avatar class="h-8 w-[165px] bg-transparent">
                        <AvatarImage src="/svg/amphora-logo.svg" />
                    </Avatar>
                </RouterLink>
            </div>
        </div>
        <SiteSearch />
        <div class="flex-1 flex items-center justify-end space-x-2">
            <CreateNewNav />
            <MyTicketsNav />
            <NewTickets />
            <UserNotifications />
            <UserNav />
        </div>
    </div>
</template>
